'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { Children, cloneElement, forwardRef, isValidElement, useMemo, } from 'react';
import styles from './list.module.css';
import { Li } from './list-item.js';
export const List = forwardRef(({ as: Component = 'ul', children, dimension = 'regular', className, hideMarker = false, gap, style, ...otherProps }, forwardedRef) => {
    const isUnordered = useMemo(() => Component === 'ul', [Component]);
    const dynamicStyle = useMemo(() => ({
        '--gap': gap ? tkns.space[gap] : 0,
    }), [gap]);
    return (_jsx(Component, { ref: forwardedRef, className: clsx(styles.List, className), "data-list-size": dimension, "data-list-ordered": !isUnordered, "data-list-no-marker": hideMarker, style: { ...dynamicStyle, ...style }, ...otherProps, children: Children.map(children, child => isValidElement(child) && cloneElement(child, {
            hideMarker: !isUnordered || hideMarker,
            dimension,
        })) }));
});
List.Li = Li;
